import React from "react";
import { motion } from "framer-motion";
import "./login.css";
import LoginSignupSide from "../utils/LoginSignupSide";
import Input from "../utils/Input";
import Logo from "../utils/Logo";
import { Link } from "react-router-dom";
const Login = () => {
  return (
    <div className="login_outer login">
      <div className="login_container">
        <motion.div animate={{ x: 0 }} initial={{ x: -(window.innerWidth) }} exit={{ x: -(window.innerWidth) }} transition={{ duration: 0.5 }} className="fixed_logo position-absolute">
          <Link to="/"><Logo color="#25bda8" bg="#fff" width="200" /></Link>
        </motion.div>
        <motion.div
          className="login_content py-5"
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: window.innerWidth > 768 ? 432 : window.innerWidth, opacity: 0 }}
          initial={{ x: window.innerWidth > 768 ? 432 : window.innerWidth, opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="login_inner">
            <h1 className="font-weight-bold mt-4">Login to Your Account</h1>
            <p>Login using social networks</p>
            <div className="form_icons">
              <div className="login_icon facebook">
                <svg
                  width="9"
                  height="15"
                  viewBox="0 0 9 15"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M5.324 3.18306C5.209 3.34006 5.147 3.52606 5.147 3.74506L5.144 5.15106H8.23L7.201 8.10306H5.144V14.9931H2.057V8.10306L0.011 8.14206L0 5.15106L2.147 5.13806V3.77306C2.147 3.27106 2.23 2.79906 2.397 2.36006C2.563 1.92006 3.082 1.64006 3.4 1.31006C3.718 0.98006 4.09 0.719061 4.518 0.527061C4.945 0.334061 5.4 0.237061 5.886 0.237061H8.246L8.229 3.18306H5.324Z" />
                </svg>
              </div>
              <div className="login_icon gmail">
                <svg
                  width="9"
                  height="15"
                  viewBox="0 0 9 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M5.324 3.18306C5.209 3.34006 5.147 3.52606 5.147 3.74506L5.144 5.15106H8.23L7.201 8.10306H5.144V14.9931H2.057V8.10306L0.011 8.14206L0 5.15106L2.147 5.13806V3.77306C2.147 3.27106 2.23 2.79906 2.397 2.36006C2.563 1.92006 3.082 1.64006 3.4 1.31006C3.718 0.98006 4.09 0.719061 4.518 0.527061C4.945 0.334061 5.4 0.237061 5.886 0.237061H8.246L8.229 3.18306H5.324Z" />
                </svg>
              </div>
              <div className="login_icon linkedin">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M12.083 8.729C12.199 8.934 12.257 9.111 12.257 9.26V15.864H15.449V9.261C15.449 8.553 15.25 7.862 14.854 7.191C14.457 6.519 13.929 6.006 13.272 5.652C12.653 5.354 11.956 5.186 11.183 5.148C10.408 5.111 9.71199 5.242 9.09299 5.54V5.036H5.84299V15.862H9.09299V8.924C9.34399 8.701 9.61598 8.524 9.90598 8.393C10.157 8.281 10.438 8.207 10.748 8.169C11.058 8.132 11.376 8.197 11.706 8.365C11.841 8.403 11.967 8.524 12.083 8.729Z" />
                  <path d="M1.24399 3.329C1.62099 3.703 2.08899 3.889 2.65099 3.889C3.21199 3.889 3.68698 3.703 4.07298 3.329C4.45998 2.956 4.65298 2.499 4.65298 1.958C4.65298 1.417 4.45998 0.956 4.07298 0.573C3.68598 0.191 3.21199 0 2.65099 0C2.08999 0 1.62099 0.191 1.24399 0.573C0.866988 0.956 0.677979 1.417 0.677979 1.958C0.677979 2.499 0.866988 2.956 1.24399 3.329Z" />
                  <path d="M1.02599 15.863H4.27599V5.036H1.02599V15.863Z" />
                </svg>
              </div>
            </div>
            <form action="" className="login_form">
              <div className="w-100 mb-3 d-flex justify-content-center align-items-center">
                <div className="line"></div>
                <p className="mb-0 font-smaller px-3">OR</p>
                <div className="line"></div>
              </div>
              <div className="fields">
                <Input type="email" placeholder="Email" />
                <Input password={true} type="password" placeholder="Password" />
              </div>
              <button className="button_login">Login</button>
            </form>
          </div>
        </motion.div>
        <LoginSignupSide
          type="signup_page"
          heading="New Here?"
          text="Sign up and discover a great amount of new opportunities!"
          link="/signup"
          linkText="Sign Up"
          x={-1}
        />
      </div>
    </div>
  );
};

export default Login;
